import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";



export const GstServices = {
    fetchGstList: async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.pageSize);
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        queryParams.append('sortType', data.filters.sortType || 'desc');
        if (data.filters.filterOptions.length>0) {
            const filter = data.filters.filterOptions[0];
            queryParams.append(`fieldName`, filter.fieldName);
            queryParams.append(`operator`, filter.operator);
            queryParams.append(`value`, filter.value);
            if (filter.operator === 'between') {
                queryParams.append(`endValue`, filter.endValue);                        
            }
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/admin/gst/sorted-list?${queryParams.toString()}`,{}, Helpers.token());
    },
    addGst: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/gst/create`, data, Helpers.token());
    },
    updateGst: async(data,id)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/gst/update/${id}`, data, Helpers.token());
    },
}